import { getLanguage } from '../utils'

const defaultLang = getLanguage()

class NumberFormatter {
  constructor() {
    this.lang = defaultLang
    this.formatter = new Intl.NumberFormat(this.lang)
    // format number with decimal for get localized decimal separator
    this.decimalSeparator = this.formatter.format(1.1).replace(/\p{Number}/gu, '')
    // format number for get localized thousand separator
    this.thousandSeparator = this.formatter.format(11111).replace(/\p{Number}/gu, '')
    this.DEFAULT_INTEGER_DIGITS = 15

    this.NEGATIVE_RE = /-/ //@regex match '-'
    this.THOUSAND_SEPARATOR_RE = new RegExp('\\' + this.thousandSeparator, 'g') //@regex match thousand separator
    this.DECIMAL_SEPARATOR_RE = new RegExp('\\' + this.decimalSeparator, 'g') //@regex match decimal separator
    this.DECIMALS_RE = new RegExp('\\' + this.decimalSeparator + '(\\d+)') //@regex match decimal separator
    this.NOT_NUMBER_OR_DECIMALS_RE = /[^0-9.,-]/ //@regex match not number characters
    this.NAN_RE = /NaN/ //@regex match 'NaN'
    this.DECIMAL_SEPARATORS_RE = /[,.]/ //@regex match decimal separator (all type)
  }

  formatNumber(number) {
    if (!number || !window.Intl) return number
    return this.formatter.format(number)
  }

  getMinimumFractionDigits(number, decimals) {
    const decimalCount = this.countDecimalDigits(number)
    return decimalCount > decimals ? decimals : decimalCount
  }

  formatNumberDecimal(number, decimals = 0, lang = defaultLang) {
    if (!number || !window.Intl) return number
    if (!decimals) decimals = 0

    const minimumFractionDigits = this.getMinimumFractionDigits(number, decimals)
    const parsedNumber = this.parseLocaleNumber(number)

    return new Intl.NumberFormat(lang, {
      style: 'decimal',
      minimumFractionDigits: minimumFractionDigits,
      maximumFractionDigits: decimals,
    }).format(parsedNumber)
  }

  parseFormatted(value) {
    return this.parseLocaleNumber(value)
  }

  countDecimalDigits(number) {
    if (!number) return 0

    const decimalMatch = number.toString().match(this.DECIMALS_RE)
    const hasDecimal = decimalMatch && decimalMatch[1]

    return hasDecimal ? decimalMatch[1].length : 0
  }

  replaceSeparators(number) {
    if (!number) return ''
    number = number.toString()
    return number.replace(this.THOUSAND_SEPARATOR_RE, '').replace(this.DECIMAL_SEPARATOR_RE, '.')
  }

  parseLocaleNumber(stringNumber) {
    const replacedNumber = this.replaceSeparators(stringNumber)
    return replacedNumber !== '-' ? parseFloat(replacedNumber) : replacedNumber
  }
}

export default new NumberFormatter()
